import React, {useCallback, useContext, useEffect} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import {useMenu} from '../../../hooks/useMenu';
import BodyContentView from '../../views/bodyContentView';

function WriteProtection({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {onComponent} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  const onRight = useCallback(() => {
    
  }, []); 

  useEffect(() => {
    if (!leftPress) return;

    onExit();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress) return;

    onRight();
  }, [rightPress]);

  useEffect(() => {
    onUpdateCommands({onLeft: onExit, onRight});
  }, [onExit, onRight]);

  return (
    <BodyContentView
      title="Write Protection"
      left="Back"
      right=""
      caption={
        <>

          <p>Write protect must enabled/disabled using the physical switch located behind the display.</p>

        </>
      }
    />
  );
}

export default WriteProtection;
